import { showDepositModal, showWithdrawalModal } from 'layouts/Header/menuActions'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const PostMessageListener = () => {
  const dispatch = useDispatch()

  const handleMessage = (event) => {
    if (event.data === 'show_deposit') {
      showDepositModal(dispatch)
    }
    if (event.data === 'show_withdrawal') {
      showWithdrawalModal(dispatch)
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return null
}

export default PostMessageListener
